<template>
    <v-container id="login" fill-height tag="section">
        <v-row justify="center">
            <v-slide-y-transition appear>
                <base-material-card color="primary" light max-width="100%" width="465" class="px-5 py-3">
                    <template v-slot:heading>
                        <div class="text-center">
                            <h1 class="display-2 font-weight-bold mb-2">
                                SC<sup>2</sup> - Reports - Login
                            </h1>
                            <v-tooltip v-for="(social, i) in socials" :key="i" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :href="social.href" class="ma-1" icon rel="noopener" target="_blank" :alt="socials.alt" v-bind="attrs" v-on="on">
                                        <v-icon :disabled="social.disabled" v-text="social.icon" />
                                    </v-btn>
                                </template>
                                <span>{{ social.tooltiptxt }}</span>
                            </v-tooltip>
                        </div>
                    </template>

                    <v-card-text class="text-center">
                        <div class="text-center grey--text body-1 font-weight-light">
                            'Discover the World'
                        </div>

                        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
                            <v-text-field
                                v-model="username"
                                :rules="[rules.required, rules.min]"
                                label="User Name.."
                                hint="At least 3 characters"
                                prepend-icon="mdi-face"
                                color="secondary"
                                class="mt-10">
                            </v-text-field>

                            <v-text-field
                                v-model="password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show1 ? 'text' : 'password'"
                                label="Password.."
                                hint="At least 3 characters"
                                prepend-icon="mdi-lock-outline"
                                counter
                                color="secondary"
                                class="mt-10"
                                @click:append="show1 = !show1">
                            </v-text-field>

                            <pages-btn color="primary" :rounded="false" class="v-btn--text" :disabled="!valid" @click="onValidate" style="color: #ffffff; margin-top:30px; margin-bottom:20px;" width="50%">
                                Let's Go
                            </pages-btn>
                        </v-form>
                    </v-card-text>
                </base-material-card>
            </v-slide-y-transition>
        </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';
    import {
        CONF_ENVIRONMENT,
        CONF_CLIENT_URLS_SC2_CALENDAR_PROD,
        CONF_CLIENT_URLS_SC2_CALENDAR_TEST,
        CONF_CLIENT_URLS_SC2_FLIGHTS_PROD,
        CONF_CLIENT_URLS_SC2_FLIGHTS_TEST,
        CONF_CLIENT_URLS_SC2_PEOPLE_PROD,
        CONF_CLIENT_URLS_SC2_PEOPLE_TEST,
        CONF_CLIENT_URLS_SC2_HOTELS_PROD,
        CONF_CLIENT_URLS_SC2_HOTELS_TEST,
        CONF_CLIENT_URLS_SC2_VACATION_PROD,
        CONF_CLIENT_URLS_SC2_VACATION_TEST,
        CONF_CLIENT_URLS_SC2_REPORTS_PROD,
        CONF_CLIENT_URLS_SC2_REPORTS_TEST,
        CONF_CLIENT_URLS_SC2_TIMESTATS_PROD,
        CONF_CLIENT_URLS_SC2_TIMESTATS_TEST,
        CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD,
        CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST,
        CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD,
        CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST,
        CONF_CLIENT_URLS_SC2_TRAININGS_PROD,
        CONF_CLIENT_URLS_SC2_TRAININGS_TEST,
        CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD,
        CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST,
    } from '../../config';


    export default {
        name: 'PagesLogin',

        /* >>> *************************************************************** / /* Components */
        components: {

            PagesBtn: () => import('./components/Btn')

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            valid: false,

            username: '',
            password: '',
            show1: false,
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 3 || 'Min 3 characters',
                emailMatch: () => ('The email and password you entered don\'t match')
            },
            // >>> ------------------------------
            socials: [
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_PEOPLE_PROD : CONF_CLIENT_URLS_SC2_PEOPLE_TEST,
                    icon: 'mdi-account-multiple', // people
                    tooltiptxt: 'People',
                    disabled: true,

                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_HOTELS_PROD : CONF_CLIENT_URLS_SC2_HOTELS_TEST,
                    icon: 'mdi-bed', // hotels
                    tooltiptxt: 'Hotels',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_VACATION_PROD : CONF_CLIENT_URLS_SC2_VACATION_TEST,
                    icon: 'mdi-beach', // vacations
                    tooltiptxt: 'Vacations',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_REPORTS_PROD : CONF_CLIENT_URLS_SC2_REPORTS_TEST,
                    icon: 'mdi-briefcase-download', // reports
                    tooltiptxt: 'Reports',
                    disabled: false,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_TIMESTATS_PROD : CONF_CLIENT_URLS_SC2_TIMESTATS_TEST,
                    icon: 'mdi-av-timer', // timestats
                    tooltiptxt: 'TimeStats',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD : CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST,
                    icon: 'mdi-airport', // airportqualifications
                    tooltiptxt: 'AirportQualifications',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD : CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST,
                    icon: 'mdi-account-check', // confirmationoverview
                    tooltiptxt: 'ConfirmationOverview',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_TRAININGS_PROD : CONF_CLIENT_URLS_SC2_TRAININGS_TEST,
                    icon: 'mdi-account-school', // trainings
                    tooltiptxt: 'Trainings&Checks',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD : CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST,
                    icon: 'mdi-book-account', // dutyplan
                    tooltiptxt: 'Dutyplan',
                    disabled: true,
                },



                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_FLIGHTS_PROD : CONF_CLIENT_URLS_SC2_FLIGHTS_TEST,
                    icon: 'mdi-airplane-takeoff', // flights
                    tooltiptxt: 'SunFlight',
                    disabled: true,
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_CALENDAR_PROD : CONF_CLIENT_URLS_SC2_CALENDAR_TEST,
                    icon: 'mdi-account-switch', // crewplanning2
                    tooltiptxt: 'Calendar',
                    disabled: true,
                },
            ]
        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_userLogin'
            ]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate()
            *
            * Desc: Check if Form is valid. If so ... Login.
            * Note:
            *
            */
            onValidate: function() {

                let me = this;


                me.$toc('>>> views/pages/Login.vue >>> onValidate');
                if (this.$refs.form.validate()) {
                    const params = {
                        username: this.username,
                        password: this.password
                    };
                    this.actn_userLogin(params);
                }

            }, // eo function onValidate()

            /*******************************************************************
            * reset()
            *
            * Desc: Reset Form.
            * Note: Still unused.
            *
            */
            reset: function() {

                this.$refs.form.reset();

            }, // eo function reset()

            /*******************************************************************
            * resetValidation()
            *
            * Desc: Reset Forms Validations.
            * Note: Still unused.
            *
            */
            resetValidation: function() {

                this.$refs.form.resetValidation();

            } // eo function resetValidation()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset;
        -moz-box-shadow: 0 0 0 100px #fff inset;
        box-shadow: 0 0 0 100px #fff inset;
        /* change the white to any color */
    }

    .v-application .ma-1 {
        margin: 0px !important;
    }
</style>

